const copyToClipboard = (params) => {
    let copyText = params;
    return navigator.clipboard.writeText(copyText);
}

export default copyToClipboard;
